// Backend compatibility boundary. Keep endpoint casing, query keys, headers,
// string budget values, and legacy payload fields aligned with the existing server.
export const SERVER = 'https://earlybirdserver-kg6sdts6eq-uc.a.run.app';
export async function readAccount(user) {
 const idToken = await user.getIdToken(true);
 const options = {headers:{idToken}};
 const [legacy,ready,payment] = await Promise.all([
  fetch(SERVER+'/userIDs?idToken='+idToken+'&userId='+user.uid, options),
  fetch(SERVER+'/userReadyIDs?idToken='+idToken+'&userId='+user.uid, options),
  fetch(SERVER+'/payment_status?idToken='+idToken, options)
 ]);
 if (legacy.status >= 500 || ready.status >= 500 || payment.status >= 500) throw new Error('We could not load your account. Please try again.');
 // A failed lookup must never be mistaken for a new user and trigger writes.
 if (!ready.ok && ![400,404].includes(ready.status)) throw new Error('Your alert settings could not be verified. Please sign in again or retry.');
 if (!payment.ok && ![400,402,403,404].includes(payment.status)) throw new Error('Your subscription could not be verified. Please retry.');
 return {ready:ready.ok ? await ready.json() : null, payment:payment.ok ? await payment.json() : null};
}
export async function initializeAlerts(user) {
 let idToken = await user.getIdToken(true);
 const ready = await fetch(SERVER+'/userReadyIDs?idToken='+idToken+'&userId='+user.uid+'&skipped=true', {
  method:'POST',headers:{'Content-Type':'application/json',idToken},body:JSON.stringify({id:user.uid})
 });
 if(!ready.ok) throw new Error('Could not initialize your alert account. Please retry.');
 idToken = await user.getIdToken(true);
 const profiles = await fetch(SERVER+'/user_profiles?idToken='+idToken+'&userId='+user.uid+'&freelancerId='+user.uid, {
  method:'POST',headers:{'Content-Type':'application/json',idToken},body:JSON.stringify({profiles:[]})
 });
 if(!profiles.ok) throw new Error('Your account setup is incomplete. Please contact support before continuing.');
}
export function settingsPayload(user, existing, preferences, deactivateAcc=false) {
 return {emailAlerts:preferences.emailAlerts,refreshProfile:false,model:existing.model || 'gpt-4o',customPrompt:existing.customPrompt || '',keydata:'',keyid:'',deleteApiKey:false,projecttypes:existing.projecttypes || [],id:user.uid,tags:preferences.tags,fixed:preferences.fixed,hourly:preferences.hourly,deactivateAcc,profileUrl:''};
}
export async function savePreferences(user, existing, preferences, deactivateAcc=false) {
 const idToken = await user.getIdToken(true);
 const response = await fetch(SERVER+'/userReadyIDs?idToken='+idToken+'&userId='+(existing.id || user.uid), {
  method:'POST',headers:{'Content-Type':'application/json',idToken},body:JSON.stringify(settingsPayload(user,existing,preferences,deactivateAcc))
 });
 if(!response.ok) throw new Error('Your changes could not be saved. Please try again.');
}
export async function verifyPayment(user, sessionID) {
 const idToken = await user.getIdToken(true);
 const response = await fetch(SERVER+'/payment_session?sessionID='+encodeURIComponent(sessionID)+'&idToken='+idToken,{headers:{idToken}});
 if(!response.ok) throw new Error('Payment could not be verified yet. Please retry. You will not be charged again by retrying verification.');
 return response.json();
}
export async function customerPortal(user,customerId) {
 const idToken = await user.getIdToken(true);
 // Keep the historical return URL: this path remains a supported alias.
 const returnUrl=window.location.origin+'/new-projects';
 const response=await fetch(SERVER+'/payment_create-customer-portal-session?idToken='+idToken,{
  method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({customerId,returnUrl})
 });
 if(!response.ok) throw new Error('Could not open billing. Please try again.');
 const data=await response.json();
 if(!data.url || !data.url.startsWith('https://')) throw new Error('No secure billing URL was returned. Please contact support.');
 return data.url;
}

export async function readJobs(user, preferences, signal) {
 const tags = [...new Set(preferences.tags || [])];
 if (!tags.length) return [];
 const idToken = await user.getIdToken(true);
 // Chunk Firestore array-contains-any queries, retaining the existing API contract.
 const batches=[];
 for(let i=0;i<tags.length;i+=10) batches.push(tags.slice(i,i+10));
 const results=[];
 for(const batch of batches) {
  const params=new URLSearchParams({idToken,tags:batch.join('|||'),fixed:String(preferences.fixed || 0),hourly:String(preferences.hourly || 0)});
  const response=await fetch(SERVER+'/projects?'+params.toString(),{headers:{idToken},signal});
  if(!response.ok) throw new Error(response.status===401?'Your session has expired. Please sign in again.':'We could not load your jobs. Please try again.');
  const data=await response.json();
  if(!Array.isArray(data)) throw new Error('We received an unexpected response. Please retry.');
  results.push(...data);
 }
 const seen=new Set();
 return results.filter(job=>{if(!job || typeof job!=='object')return false;const key=job.docName || job.Id;if(!key)return true;if(seen.has(key))return false;seen.add(key);return true;});
}
